
import { mapActions, mapGetters } from "vuex";
import { validationMixin } from "vuelidate";
import { SistemaMixin } from "@/modules/Application";
import { PessoaMixin } from "@/modules/Application";
import ConfigBoletoData, { ConfigBoletoDataRequired } from "./ConfigBoletoData";
import { Money } from "v-money";
import { MONEY as settingMoney } from "@/modules/Application";
import Quest from "vue-material-design-icons/AccountQuestion.vue";
export default {
  name: "app-config-boleto",
  data() {
    return {
      url: null,
      tabIndex: 0,
      configMoney: settingMoney,
      form: null,
      configBoleto: new ConfigBoletoData({}),
      modeFee: [
        {
          code: "FIXED",
          description: "Valor fixo para o tipo de multa",
        },
        {
          code: "PERCENTAGE",
          description: "Porcentagem baseado no valor do boleto",
        },
      ],
      modeInterest: [
        {
          code: "DAILY_AMOUNT",
          description:
            "Valor diário para incidência de juros após um dia corrido da data de vencimento",
        },
        {
          code: "DAILY_PERCENTAGE",
          description:
            "Percentual diário para incidência de juros após um dia corrido da data de vencimento.",
        },
        {
          code: "MONTHLY_PERCENTAGE",
          description:
            "Percentual mensal para incidência de juros após um dia corrido da data de vencimento.",
        },
      ],
      modeDiscount: [
        {
          code: "FIXED",
          description: "Valor fixo para o desconto",
        },
        {
          code: "PERCENTAGE",
          description: "Porcentagem baseado no valor do boleto",
        },
      ],
    };
  },
  mixins: [validationMixin, SistemaMixin, PessoaMixin],
  computed: {
    ...mapGetters(["itsblocked"]),
  },
  validations: {
    form: ConfigBoletoDataRequired,
  },
  components: {
    Money,
    Quest,
  },
  watch: {
    configBoleto(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.form = newValue;
      }
    },
  },
  methods: {
    ...mapActions(["setLoading"]),
    async getConfigBoletoByEmpresa() {
      const { data } = await this.$http.post("/boletos/find-empresa");
      return data;
    },
    setUseLogo() {
      this.form.use_logo = this.form.use_logo == true ? false : true;
    },
    async getInit() {
      try {
        this.setLoading(true);
        const configBoleto = await this.getConfigBoletoByEmpresa();
        this.setLoading(false);
        if (!configBoleto.id_config_boleto || configBoleto == null) {
          this.configBoleto = new ConfigBoletoData({});
          this.url = "/boletos/create-config";
          return;
        }
        this.configBoleto = new ConfigBoletoData(configBoleto);
        this.configBoleto.id_config_boleto = configBoleto.id_config_boleto;
        this.url = "boletos/update-config";
      } catch {
        return;
      }
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    async onSubmit() {
      const submitButton = this.$refs["submit_config_boleto"];
      try {
        this.$v.form.$touch();
        if (this.$v.form.$anyError) {
          this.$toast.error(
            "Verifique todos os campos obrigatórios do formulário!"
          );
          return;
        }
        submitButton.classList.add("spinner", "spinner-light", "spinner-right");
        submitButton.setAttribute("disabled", "");
        await this.$http.post(this.url, this.form);
        this.$toast.success("Configuração cadastrada com sucesso!");
        await this.getInit();
        submitButton.classList.remove(
          "spinner",
          "spinner-light",
          "spinner-right"
        );
        submitButton.removeAttribute("disabled", "");
      } catch (error) {
        submitButton.classList.remove(
          "spinner",
          "spinner-light",
          "spinner-right"
        );
        submitButton.removeAttribute("disabled", "");
      }
    },
  },
  async mounted() {
    if (this.itsblocked) {
      this.$router.push({ name: "assinatura" });
    }
    await this.getInit();
  },
};
